import React, { useState, useCallback, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon, Button, Switch ,message, Dropdown, Menu, Spin, Select, Tooltip } from 'antd';
import {
  Container,
  Title
} from '../../../artboard/VariablesList/styles';
import { TEMPLATE_VARIABLES_SIDEBAR } from '../../../artboard/VariablesList/translationValues';
import { COMPLEX_VARIABLES_SIDEBAR } from './translationValues';
import {
  TitleContainer,
  RowSection,
  ListContainer,
} from './styles';
import { DownloadButton } from '../styles';
import { useDocumentContext, COMPLEX_DOCUMENT_CONTEXT_KEYS } from '../../../context/complexDocumentContext';
import { getTodaysDateWithFormat, jsonToFile, xmlToFile } from '../../../utils/javascript';
import { generatePDF, showDesignbroadcast, releaseDesignbroadcast, getMasterDocumentDisplayStatus, getComplexDocument, generatePayDownloadPDF } from '../../../utils/services/complexDocumentsAPI';
import { getTagsList } from '../../../utils/services/mailRoomAPI';
import { fetchStandaloneBlock } from '../../../utils/services/complexDocumentsAPI';
import { dynamicTableHasMoreThanTwoLevels, generatePDFPayload, processCachedDataSet } from '../complexDocumentHelper';
import { VARIABLE_OBJECT_TYPES, VARIABLE_TYPE, ALL_VARIABLE_OBJECT_TYPES } from '../../../utils/constants/appConstants';
import { useArtboardContext, CONTEXT_KEYS, TEMPLATE_TYPE } from '../../../context/complexArtboardContext';
import { useSessionContext } from '../../../context/sessionContext';
import { checkSessionUserAccess, checkUserAccessRoles } from '../../../utils/helper';
import { useDefaultStyleContext } from '../../../context/complexDefaultStyleContext';
import VariableForm from './VariableForm';
import './styles.css'; 
import { Document, Page } from 'react-pdf';
import { useIntersectionObserver } from "@wojtekmaj/react-hooks";
import { DOCUMENT_TEMPLATES_MENUBAR, TEMPLATE_PREVIEW_MODAL, docGenerationUpgradeMessages } from '../MenuBar/translationValues';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import SelectOrganization from '../../../components/SelectionOrganization';
import { staticDownload, uploadEnvDataSet } from '../../../utils/services/documentAPI';
import { PDF_TRANSACTIONS, TRANSACTIONS } from '../../TemplateSection/translationValues';
import { generateSampleExcel, getPayloadFromFile, getXMLFromJSON } from '../../../utils/transactionHelpers';
import { getJsonFromArraybuffer, handleDataValidationErrors } from '../../../utils/dataValidationHelper';
import { COMPLEX_DOCUMENT_VERSION, DOCUMENT_PREVIEW_ERROR_CODES, versionsApiMap } from '../../../utils/complexDocumentConstants';
import { toZipFile } from '../../../utils/javascript';
import AccessibilityPreview from './AccessibilityPreview';
import { generateInteractiveDoc, getInteractiveDesign } from '../../../utils/services/interactiveDesignApi';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import TransactionCompleteModal from '../../../components/Modals/TransactionCompleteModal';
import { getIndexedDBData } from '../../../utils/indexedDBUtil';
import { useEmbedding } from '../../../context/embedContext';
import { PdsClientEventName } from '../../../../shared';
import { isInIframe, parentWindow } from '../../../utils/embedHelper';
import SignUpPrompt from '../../../components/Modals/SignUpPrompt';
import { useVersionContext, VERSION_CONTEXT_KEYS } from '../../../context/complexVersionContext';
import { getSampleDataSet, generateCSVHeadersFromJSON, downloadDelimitedFile, generatePayloadFromCsvFile, parseFileWithKnownDelimiters } from '../../../utils/helper';
import { checkFileFormat } from '../../../utils/transactionHelpers';

const dummyCallback = () => {};

const { Option } = Select;

const checkUserAccess = (userType, roles, userDetails = {}) => {
  if (roles) {
    return (
      userDetails?.userType === userType && userDetails.roles.some(role => roles.includes(role))
    );
  } else {
    return userDetails?.userType === userType;
  }
};

const _NAMESPACES = ['TEMPLATE_PREVIEW_MODAL', 'TRANSACTIONS'];

export const PreviewLoader = ({ containerStyle = {} }) => {
  const { t } = useTranslation(_NAMESPACES);
  return (
    <div className="loader-container" style={containerStyle}>
      <div class="loader-content">
        <img src={'tech_loader.gif'} width={'100px'} alt="" />
        <h1>
          {t(
            `TEMPLATE_PREVIEW_MODAL:${TEMPLATE_PREVIEW_MODAL.PREVIEW_LOADER_TITLE.key}`,
            TEMPLATE_PREVIEW_MODAL.PREVIEW_LOADER_TITLE.value,
          )}
        </h1>
        <p>
          {t(
            `TEMPLATE_PREVIEW_MODAL:${TEMPLATE_PREVIEW_MODAL.PREVIEW_LOADER_MESSAGE.key}`,
            TEMPLATE_PREVIEW_MODAL.PREVIEW_LOADER_MESSAGE.value,
          )}
        </p>
      </div>
    </div>
  );
};

const constructChartVariable = (variables, isFormTable = false) => {
  const source = {};
  const header = [];
  variables.forEach(item => {
    header.push(item.placeHolderText);
    Object.keys(item).forEach(key => {
      if (key === 'placeHolderText') {
        if (isFormTable) {
          if (item.placeHolderText === 'selected') {
            source[item.placeHolderText] = 'false';
          } else {
            source[item.placeHolderText] = '';
          }
        } else {
          source[item.placeHolderText] = item.exampleValue || '';
        }
      }
    });
  });
  return { header, source: [source], isObject: true };
};

const NAMESPACES = ['TEMPLATE_VARIABLES_SIDEBAR', 'COMPLEX_VARIABLES_SIDEBAR', 'TEMPLATE_PREVIEW_MODAL'];

const observerConfig = {
  threshold: 0,
};

const PreviewPageWithObserver = ({ pageNumber, setPageVisibility }) => {
  const [page, setPage] = useState();

  const onIntersectionChange = useCallback(
    ([entry]) => {
      console.log("pageNumber intersecting :: ", pageNumber);
      setPageVisibility(pageNumber, entry.isIntersecting);
    },
    [pageNumber, setPageVisibility],
  );

  useIntersectionObserver(page, observerConfig, onIntersectionChange);

  useEffect(() => {
    if (pageNumber === 1 && page) {
      setTimeout(() => {
        console.log("preview page :: ", page);
        // page.getContext('2d').fillRect(100, 100, 100, 100);
        const context = page.getContext('2d');
        const hybridAddressValidatorDOM = document.getElementById('hybridAddressValidator');
        if (!hybridAddressValidatorDOM) return;
        const { width, height, transform, borderColor } = hybridAddressValidatorDOM.querySelector('span')?.style;
        const transformStyles = transform.split(' ');
        let extractedTransform = {};
          transformStyles.forEach(data => {
            let key = data.split('(')[0];
            let value = data && data.match(/\((.*)\)/)[1];
            value = Number(value.replace(/[^\d.-]/g, ''));
            let pair = { [key]: value };
            extractedTransform = { ...extractedTransform, ...pair };
          });
        const x = extractedTransform.translateX;
        const y = extractedTransform.translateY;
        console.log({ borderColor });
        context.strokeStyle = borderColor;
        context.lineWidth = 2;
        context.scale(1.4 * 1.5, 1.4 * 1.5);
        context.strokeRect(x, y, parseInt(width.replaceAll('px', '')), parseInt(height.replaceAll('px', ''))); // TODO : Get details of addressWindow and imitate the color and dimensions
      }, 1000);
    }
  }, [page, pageNumber]);

  return (
    <Page
      canvasRef={setPage}
      pageNumber={pageNumber}
      scale={1.4}
      renderTextLayer={false}
      renderAnnotationLayer={true}
      renderForms={true}
      loading=''
      error=''
    />
  );
};

const setInitialExampleValueData = () => {
  const variableData = JSON.parse(sessionStorage.getItem('datasetCache')) ? JSON.parse(sessionStorage.getItem('datasetCache')) : {};
  return variableData;
}

let setLoaderFunc;

const ComplexVariablesList = props => {
  const { globalVariables, documentVariables, businessLogics,setIsHtmlExpanded,isHtmlExpanded } = props;
  const { t } = useTranslation(NAMESPACES);
  const { embedState } = useEmbedding();
  const [generatingPreview, setIsGeneratingPreview] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [numPages, setNumPages] = useState();
  const containerRef = useRef(null);
  const fileRef = useRef(null);
  const [examplValuesData, setExamplValuesData] = useState(setInitialExampleValueData);
  const [tagsData, setTagsData] = useState([]);
  const [stationeryList, setStationeryList] = useState([]);

  const contextSelector = useCallback(store => store, []);
  const [documentContext, methods] = useDocumentContext(contextSelector);
  const getCurrentDesign = useCallback(store => store[CONTEXT_KEYS.CURRENT_DESIGN], []);
  const [CurrentDesign, updateArtboard] = useArtboardContext(getCurrentDesign);
  const [toggleButton, setToggleBUtton] = useState(false);
  const [designReleaseLoading, setDesignReleaseLoading] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const [accessibilityPreview, setAccessibilityPreview] = useState(0);
  const { documentId } = useParams();
  const responseData =  useRef();

  const sessionSelector = useCallback(store => store.userData, []);
  const [userDetails] = useSessionContext(sessionSelector);

  const loaderSelector = useCallback(store => store[CONTEXT_KEYS.GENERATING_PDF], []);
  const [generatingPDF] = useArtboardContext(loaderSelector, 'ComplexVariablesList');

  const dataSetSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.DATA_SET], []);
  const [documentDataSet] = useDocumentContext(dataSetSelector);

  const interactiveDocumentIdSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.INTERACTIVE_DOCUMENT_ID], []);
  const [interactiveDocumentId] = useDocumentContext(interactiveDocumentIdSelector);

  const blocksNotFit = document.getElementsByClassName('block-not-fit');
  const disablePreviewDownload = blocksNotFit.length > 0;

  const getDefaultStyleSelector = useCallback(store => ({fontFamily: store.fontFamily, fontSize:store.fontSize}), []);
  const [documentStyle] = useDefaultStyleContext(getDefaultStyleSelector);

  const interactiveDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_INTERACTIVE_DESIGN], []);
  const [isInteractiveDesign] = useArtboardContext(interactiveDesignSelector, `ComplexVariablesList`);

  const isOpenDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_OPEN_DESIGN], []);
  const [isOpenDesign] = useArtboardContext(isOpenDesignSelector, `ComplexVariablesList`);

  const isHybridMailSelector = useCallback(store => store[CONTEXT_KEYS.IS_HYBRID_MAIL], []);
  const [isHybridMail] = useArtboardContext(isHybridMailSelector, `ComplexVariablesList`);

  const envelopeTypeSelector = useCallback(store => store[CONTEXT_KEYS.SELECTED_ENVELOPE_TYPE], []);
  const [envelopeType] = useArtboardContext(envelopeTypeSelector, `ComplexVariablesList`);

  const deliveryClassSelector = useCallback(store => store[CONTEXT_KEYS.DELIVERY_CLASS], []);
  const [deliveryClass] = useArtboardContext(deliveryClassSelector, `ComplexVariablesList`);

  const stationerySelector = useCallback(store => store[CONTEXT_KEYS.STATIONERY], []);
  const [selectedStationery] = useArtboardContext(stationerySelector, `ComplexVariablesList`);

  const artboardVersionSelector = useCallback(store => store[CONTEXT_KEYS.ARTBOARD_VERSION], []);
  const [artboardVersion] = useArtboardContext(artboardVersionSelector, `ComplexVariablesList`);

  const readonlySelector = useCallback(store => store[CONTEXT_KEYS.READONLY_TEMPLATE], []);
  const [readOnly] = useArtboardContext(readonlySelector, `ComplexVariablesList`);

  const [showOrganizationList, setShowOrganizationList] = useState(false);
  const [organizationId, setOrganizationId] = useState('DEFAULT');

  const isMailRoomModuleEnabled = checkUserAccess('client', ['MAILROOMADMIN', 'MAILROOMCLIENT'], userDetails);

  const [showTransacModal, setShowTransacModal] = useState(false);

  const renderingTypeSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.RENDERING_TYPE], []);
  const [renderingType] = useDocumentContext(renderingTypeSelector);

  const accessibilitySelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_ACCESSIBLE], []);
  const [accessibilityEnabled] = useDocumentContext(accessibilitySelector, `ComplexVariablesList`);

  const templateDescriptionSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.TEMPLATE_DESCRIPTION], []);
  const [templateDescription] = useDocumentContext(templateDescriptionSelector, `ComplexVariablesList`);

  const hybridMailDetailsRef = useRef({
     stationaryId: selectedStationery === 1 ? undefined : selectedStationery,
     deliveryClass: deliveryClass,
     envelopSize: envelopeType
   });

  const versionContextSelector = useCallback(store => {
    return {
      currentVisibleTag: store[VERSION_CONTEXT_KEYS.CURRENT_VISIBLE_TAG],
      currentVisibleVersion: store[VERSION_CONTEXT_KEYS.CURRENT_VISIBLE_VERSION],
      versionSettingsVisible: store[VERSION_CONTEXT_KEYS.VERSION_SETTINGS_VISIBLE],
    };
  }, []);
  const [{ currentVisibleTag, currentVisibleVersion, versionSettingsVisible }] = useVersionContext(
    versionContextSelector,
    `ComplexVariablesList`,
  );
  
  const [showSignUpPrompt, setShowSignUpPrompt] = useState(false);
  const [payBtnLoading, setPayBtnLoading] = useState(false);

  const history = useHistory();

  const transactionRef = useRef(null);

   useEffect(() => {
    const handler = (e) => {
      const { isPreview, downloadPayload, format, isCompleteTransaction = true } = e.detail;
      setLoaderFunc = e.detail.setLoader;
      downloadTemplate(isPreview, downloadPayload, undefined, format, isCompleteTransaction);
    };

    const element = transactionRef.current;
    if (element) {
      element.addEventListener('startDownload', handler);
    }

    return () => {
      if (element) {
        element.removeEventListener('startDownload', handler);
      }
    };
  }, [downloadTemplate]);

  // Listen for preview events from parent window when embedded in iframe
  const isEmbedded = embedState?.isEmbedded;
  useEffect(() => {
    if (!isEmbedded || !isInIframe) return;

    const handleParentMessage = (event) => {
      const { type, action, attachments } = event.data || {};
      
      if (type === 'PDS_PREVIEW' && action === 'enablePreview') {
        // Call preview function and wait for result
        downloadTemplate(true, undefined, undefined, undefined, undefined, undefined, attachments).then((result) => {
          if (result?.success) {
            // Send success response back to parent frame
            parentWindow.postMessage({
              type: 'PDS_PREVIEW_RESPONSE',
              status: 'success',
              message: 'Preview has been enabled'
            }, '*');
          } else {
            // Send error response back to parent frame
            parentWindow.postMessage({
              type: 'PDS_PREVIEW_RESPONSE',
              status: 'error',
              message: result?.error || 'Error generating preview'
            }, '*');
          }
        });
      }
      
      if (type === 'PDS_EXIT_PREVIEW' && action === 'exitPreview') {
        // Exit preview mode
        updateArtboard({ [CONTEXT_KEYS.IS_PREVIEW]: false });
        setPdfUrl('');
        setIsGeneratingPreview(false);
        
        // Send response back to parent frame
        parentWindow.postMessage({
          type: 'PDS_EXIT_PREVIEW_RESPONSE',
          status: 'success',
          message: 'Preview has been exited'
        }, '*');
      }
    };

    window.addEventListener('message', handleParentMessage);

    return () => {
      window.removeEventListener('message', handleParentMessage);
    };
  }, [isEmbedded, downloadTemplate, updateArtboard]);

  useEffect(() => {
    if (checkSessionUserAccess(userDetails, 'master')) {
      (async () => {
        const displayStatus = await getMasterDocumentDisplayStatus(documentId);

        if (displayStatus?.statusCode === 3005) {
          setToggleBUtton(displayStatus.data.visible);
          setOrganizationId(displayStatus.data.organizationId);
        }
      })();
    }
  }, [])

  useEffect(() => {
    (async () => {
      if (isMailRoomModuleEnabled) {
        let tagsData = await getTagsList();
        if (tagsData && tagsData.data) {
          setTagsData(tagsData?.data);
        }
      }
    })();
  }, [isMailRoomModuleEnabled]);

  useEffect(() => {
    (async () => {
      if (isHybridMail) {
        const response = await fetchStandaloneBlock({
          tags: 'stationery'
        });
        const listOfStationeries = [{ parentBlockName: 'None', parentBlockId: 1 }, ...response.data];
        setStationeryList(listOfStationeries);
      }
    })();
  }, [isHybridMail]);

  useEffect(() => {
    hybridMailDetailsRef.current = {
       stationaryId: selectedStationery === 1 ? undefined : selectedStationery,
       deliveryClass: deliveryClass,
       envelopSize: envelopeType
     };
  }, [deliveryClass, envelopeType, selectedStationery]);

  const buildChartValue = (childVar, chartData) => {
    const sourceArray = chartData.map(iDataSet => {
      const source = {};
      Object.keys(iDataSet).forEach(sKey => {
        source[sKey] = iDataSet[sKey];
      });
      return source;
    });
    const chartValueVariable = constructChartVariable(childVar.variables);
    chartValueVariable.source = sourceArray;
    return chartValueVariable;
  };

  const buildValueObject = (repeatVariables, element, index, dataSet, parent = undefined) => {
    return Object.entries(dataSet)
      .map(([sKey, value]) => {
        const childVar = repeatVariables.find(v => v.placeHolderText === sKey);
        if (!childVar) return null;
  
        // Handle chart object
        if (childVar.type === VARIABLE_TYPE.CHART_OBJECT) {
          value = buildChartValue(childVar, value);
        }
  
        // Handle nested arrays (recursive case)
        if (childVar.type === VARIABLE_TYPE.TABLE_OBJECT) {
          const modifiedValue = Array.isArray(value) ? value : [value];
          const objArr = modifiedValue.map((innerDataSet, innerIndex) => ({
            key: `block${innerIndex + 1}`,
            value: buildValueObject(
              childVar.variables,
              childVar,
              innerIndex,
              innerDataSet,
              `${parent ? `${parent}.` : ''}block${index + 1}`
            ),
          }));
  
          return {
            key: element.name,
            subKey: `block${index + 1}`,
            name: sKey,
            type: childVar.type,
            isObject: true,
            parent,
            value: {
              value: objArr,
              type: element.type,
              key: childVar.name,
            },
            isArray: Array.isArray(value),
          };
        }
  
        // Simple (non-array) variable
        return {
          key: element.name,
          subKey: `block${index + 1}`,
          name: sKey,
          type: childVar.type,
          isObject: true,
          parent,
          value,
          isArray: false,
        };
      })
      .filter(Boolean);
  };

  // reverse create example values from dataset
  const processInteractiveDesignDataSet = () => {
    let sampleData = {};
    documentVariables.forEach((element, index) => {
      if (element.type === 'ListString' || element.type === 'listOfStrings') {
        sampleData = {
          ...sampleData,
          [element.placeHolderText]: {
            key: element.placeHolderText,
            value: documentDataSet[element.placeHolderText] || [],
          },
        };
      } else if (
        element.type === VARIABLE_TYPE.CHART_OBJECT ||
        element.type === VARIABLE_TYPE.FORM_OBJECT
      ) {
        const objArray = [];
        const sourceArray = [];
        documentDataSet[element.name].forEach(iDataSet => {
          const source = {};
          Object.keys(iDataSet).forEach(sKey => {
            source[sKey] = iDataSet[sKey];
          });
          sourceArray.push(source);
        });
        const chartValueVariable = constructChartVariable(element.variables);
        chartValueVariable.source = sourceArray;
        objArray.push({
          key: element.name,
          subKey: 'block1',
          name: element.placeHolderText,
          type: element.type,
          isObject: true,
          value: chartValueVariable,
        });
        sampleData = {
          ...sampleData,
          [element.placeHolderText]: {
            value: [{ key: 'block1', value: objArray }],
            type: element.type,
            key: element.name,
          },
        };
      } else if (VARIABLE_OBJECT_TYPES.includes(element.type) || element.type === VARIABLE_TYPE.TABLE_OBJECT) {
        let totalArray = [];
        const repeatVariables = documentVariables.find(i => i.name === element.name).variables;
        let objArray = []
        documentDataSet[element.placeHolderText].forEach((idataSet, index) => {
          objArray.push(buildValueObject(repeatVariables, element, index, idataSet));
          totalArray.push({ key: `block${index + 1}`, value: objArray[index] });
        });
        sampleData = {
          ...sampleData,
          [element.placeHolderText]: {
            value: totalArray,
            type: element.type,
            key: element.name,
          },
        };
      } else {
        sampleData = {
          ...sampleData,
          [element.placeHolderText]:
            element.type === 'Date'
              ? { key: element.placeHolderText, value: documentDataSet[element.placeHolderText] || '' }
              : { key: element.placeHolderText, value: documentDataSet[element.placeHolderText] || '' },
        };
      }
    });
    const datasetCache = JSON.parse(sessionStorage.getItem('datasetCache'));
    if (datasetCache) {
      const mergedSampleDataSet = processCachedDataSet(sampleData, datasetCache);
      setExamplValuesData(mergedSampleDataSet);
    } else {
      setExamplValuesData(sampleData);
    }
  };

  useEffect(() => {
    if (documentVariables?.length > 0) {
      const getSampleData = (variables, parent = undefined) => {
        let sampleData = {};
        let newBlockName = `block1`;
        variables.forEach((element, index) => {
          if (element.type === 'ListString' || element.type === 'listOfStrings') {
            sampleData = {
              ...sampleData,
              [element.placeHolderText]: {
                key: element.placeHolderText,
                value: element.exampleValue ? [element.exampleValue] : [],
              },
            };
          } else if (element.type === VARIABLE_TYPE.CHART_OBJECT) {
            const objArray = [];
            objArray.push({
              key: element.name,
              subKey: newBlockName,
              name: element.placeHolderText,
              type: element.type,
              isObject: true,
              value: constructChartVariable(element.variables),
              parent
            });
            sampleData = {
              ...sampleData,
              [element.placeHolderText]: {
                value: [{ key: newBlockName, value: objArray }],
                type: element.type,
                key: element.name,
              },
            };
            // console.log("element name :: ", element.name, sampleData);
          } else if (element.type === VARIABLE_TYPE.FORM_OBJECT) {
            const objArray = [];
            objArray.push({
              key: element.name,
              subKey: newBlockName,
              name: element.placeHolderText,
              type: element.type,
              isObject: true,
              value: constructChartVariable(element.variables, true),
              parent
            });
            sampleData = {
              ...sampleData,
              [element.placeHolderText]: {
                value: [{ key: newBlockName, value: objArray }],
                type: element.type,
                key: element.name
              },
            };
          } else if (VARIABLE_OBJECT_TYPES.includes(element.type) || element.type === VARIABLE_TYPE.TABLE_OBJECT) {
            let objArray = [];
            element.variables.forEach(eachVar => {
              objArray.push({
                key: element.name,
                subKey: newBlockName,
                name: eachVar.placeHolderText,
                type: eachVar.type,
                isObject: true, // TODO : Continue from here to do CRUD operations
                parent,
                value:
                  eachVar.type === 'Date'
                    ? getTodaysDateWithFormat()
                    : eachVar.type === 'ListString' || eachVar.type === 'listOfStrings'
                    ? eachVar.exampleValue
                      ? [eachVar.exampleValue]
                      : []
                    : eachVar.type === VARIABLE_TYPE.CHART_OBJECT
                    ? constructChartVariable(eachVar.variables)
                    : (eachVar.type === 'object' || eachVar.type === VARIABLE_TYPE.TABLE_OBJECT)
                    ? getSampleData([eachVar], `${parent ? `${parent}.` : ''}${newBlockName}`)[eachVar.placeHolderText]
                    : (eachVar.exampleValue || ''),
                extraInfo: eachVar?.extraInfo,
                listInfo: eachVar?.listInfo,
                numberInfo: eachVar?.numberInfo,
                isArray: eachVar.isArray || false
              });
            });
            sampleData = {
              ...sampleData,
              [element.placeHolderText]: {
                value: [{ key: newBlockName, value: objArray }],
                type: element.type,
                key: element.name
              },
            };
          } else {
            sampleData = {
              ...sampleData,
              [element.placeHolderText]:
                element.type === 'Date'
                  ? { key: element.placeHolderText, value: getTodaysDateWithFormat() }
                  : { key: element.placeHolderText, value: element.exampleValue },
            };
          }
        });
        return sampleData;
      };
      if (!isInteractiveDesign) {
        let designSampleData = getSampleData(documentVariables);
        const datasetCache = JSON.parse(sessionStorage.getItem('datasetCache'));
        if (datasetCache) {
          console.log("coming here :: ", datasetCache);
          const mergedSampleDataSet = processCachedDataSet(designSampleData, datasetCache);
          console.log({ mergedSampleDataSet });
          setExamplValuesData(mergedSampleDataSet);
        } else {
          setExamplValuesData(designSampleData);
        }
      } else {
        processInteractiveDesignDataSet();
      }
    }
  }, [documentVariables]);

  const setIsGeneratingPDF = useCallback((value) => {
    updateArtboard({
      [CONTEXT_KEYS.GENERATING_PDF]: value
    })
  }, []);

  useEffect(() => {
    sessionStorage.setItem('datasetCache', JSON.stringify(examplValuesData));
  }, [examplValuesData]);

  const downloadTemplate = useCallback(
    async (isPreview, downloadPayload = false, e = undefined, format = 'json', isCompleteTransaction = false, isPayDownload = false, attachments) => {
      setIsHtmlExpanded(false)
      if (e) e.domEvent.stopPropagation();
      const setGeneratingState = state => {
        if (isPreview) {
          setIsGeneratingPreview(state);
        } else {
          setIsGeneratingPDF(state);
        }
      };
      if (format === 'csv' || format === 'psv' || format === 'tsv') {
        if (documentVariables.length > 0) {
          const { hasMoreThanTwoLevels } = dynamicTableHasMoreThanTwoLevels(documentVariables);
          if (hasMoreThanTwoLevels) {
            message.warning(t(
              TRANSACTIONS.WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD.key,
              TRANSACTIONS.WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD.value,
            ));
            return;
          }
        }
        const dataset = getSampleDataSet(documentVariables, globalVariables, 'flatFile','draft',false);
        const headers = generateCSVHeadersFromJSON(dataset);
        const templateName = documentContext['documentName'];
        downloadDelimitedFile({templateName,headers, format: format });
        return;
      }

      if (!downloadPayload) {
        setGeneratingState(true);
        setErrorMessages({});
      }
      if(isCompleteTransaction) {
        setIsGeneratingPDF(false)
        setIsGeneratingPreview(false);
      }
      isPreview && updateArtboard({ [CONTEXT_KEYS.IS_PREVIEW]: true });
      let dataSet = { };
      const generateDataSet = (variable, parentDataSet = {}, sampleData = {}, nested = false) => {
        if (variable.type === VARIABLE_TYPE.OBJECT || variable.type === VARIABLE_TYPE.TABLE_OBJECT || variable.type === VARIABLE_TYPE.GROUP_OBJECT) {
          let isArray = nested ? (variable.isArray || false) : true;
          let listArray = [];
          let d = sampleData?.value?.forEach(eachBlock => {
            let blockSamples = {};
            eachBlock.value.forEach(block => {
              if (block.type === VARIABLE_TYPE.CHART_OBJECT) {
                blockSamples[block.name] = block.value.source;
              } else if (block.type === VARIABLE_TYPE.TABLE_OBJECT) {
                blockSamples = generateDataSet(
                  variable.variables.find(v => v.placeHolderText === block.name),
                  blockSamples,
                  block.value,
                  variable.type === VARIABLE_TYPE.OBJECT ? !variable.isArray : variable.type === VARIABLE_TYPE.GROUP_OBJECT ? false : true
                );
              } else {
                blockSamples[block.name] = block.value;
              }
            });
            listArray.push(blockSamples);
          });
          parentDataSet = {
            ...parentDataSet,
            [variable.placeHolderText]: isArray ? listArray : listArray[0],
          };
        } else if (variable.type === VARIABLE_TYPE.CHART_OBJECT || variable.type === VARIABLE_TYPE.FORM_OBJECT) {
          const listArray = [];
          sampleData &&
            sampleData.value &&
            sampleData.value.forEach(eachBlock => {
              let blockSamples = {};
              eachBlock.value.forEach(block => {
                blockSamples[block.name] = block.value.source;
              });
              listArray.push(blockSamples);
            });
          parentDataSet = {
            ...parentDataSet,
            ...listArray[0],
          };
        } else {
          parentDataSet = {
            ...parentDataSet,
            [variable.placeHolderText]: sampleData?.value || '',
          };
        }
        return parentDataSet;
      }
      dataSet = {
        ...dataSet,
        uniq_id:'',
        uniq_name:''
      };
      !isInteractiveDesign && documentVariables.forEach(variable => {
        const key = ALL_VARIABLE_OBJECT_TYPES.includes(variable.type) ? variable.name : variable.placeHolderText;
        dataSet = generateDataSet(variable, dataSet, examplValuesData[key]);
      });
      if (downloadPayload) {
        if (isMailRoomModuleEnabled) {
          const tags = tagsData.map(item => item.tagName);
          tags.forEach(key => {
            dataSet[key.replace(/\s+/g, '_')] = '';
          });
          dataSet.printable = false;
        }
        if (format === 'json') {
          jsonToFile([dataSet], `${documentContext['documentName']}-sample-request`);
        } else if (format === 'xml') {
          const xmlString = getXMLFromJSON({ request: [dataSet] });
          xmlToFile(xmlString, `${documentContext['documentName']}-sample-request`);
        }
        return;
      }
      let payload;
      if (isInteractiveDesign) {
        const response = await getInteractiveDesign(documentId);
        if (response?.statusCode === 5401 && response.data) {
          payload = Object.assign(
            {},
            {
              dataSet: response.data.dataSet,
              documentDTO: { ...response.data.documentDTO, documentId: interactiveDocumentId },
              annexes: attachments && Array.isArray(attachments) && attachments.length > 0 ? attachments?.map(v => {
                return { value: v.data, name: v.filename, pages: 1 };
              }) : undefined,
            },
          );
        }
      } else {
        payload = generatePDFPayload(
          globalVariables,
          documentContext,
          businessLogics,
          documentStyle,
          CurrentDesign,
          undefined,
          undefined,
          undefined,
          undefined,
          isInteractiveDesign,
        );
        payload.dataSet = dataSet;
      }
      try {
        payload.documentDTO.renderingType = renderingType ?? 0;
        if(isInteractiveDesign && !isPreview && isCompleteTransaction) {
          payload.shouldDeleteInteractiveDesign = true;
          setLoaderFunc && setLoaderFunc(true);
          const response = await generateInteractiveDoc(payload, documentId);
          responseData.current = response?.data?.data;      
          if(response?.status !== 200) {
              message.error(
                t(
                  TEMPLATE_PREVIEW_MODAL.ERROR_WHILE_WEBHOOK_TRANSACTION.key,
                  TEMPLATE_PREVIEW_MODAL.ERROR_WHILE_WEBHOOK_TRANSACTION.value,
                ),
              );
            const res = getJsonFromArraybuffer(response);
            setErrorMessages(handleDataValidationErrors(res));
          } else if (response?.status === 200) {
            // if (response?.data?.statusCode === 5407) {
            //   setShowTransacModal(true)
            // }
              setShowTransacModal(true)
          }
          return;
        }
        if (isHybridMail) {
          payload.hybridMailDetails = hybridMailDetailsRef.current;
        }
         // For open design new blocks blockid issue
        let counter = 1;
        const formatId = (num) => `usersBlockNum${String(num).padStart(3, "0")}`;
        payload.documentDTO.flows.forEach((flow) => {
          flow.blocks.forEach((block) => {
            if (!block?.blockId) {
              block.blockId = formatId(counter);
              counter++;
            }
          });
        });
        let response;
        if (isPayDownload) {
          setPayBtnLoading(true)
          response = await generatePayDownloadPDF(payload);
          if (response?.statusCode === 7001) {
            setShowSignUpPrompt(false);
            window.open(response.data.checkoutUrl, '_blank');
          } else {
            const res = handleDataValidationErrors(response);
            console.log(res);
            setErrorMessages(res);
            setShowSignUpPrompt(false);
            message.error(
              t(
                TEMPLATE_PREVIEW_MODAL.ERROR_WHILE_DOWNLOAD.key,
                TEMPLATE_PREVIEW_MODAL.ERROR_WHILE_DOWNLOAD.value,
              ),
            );
          }
          return;
        }
         response = await generatePDF(payload, isPreview, isOpenDesign);
        if (response?.status !== 200) {
          setGeneratingState(false);
          const res = getJsonFromArraybuffer(response);
          if (isPreview) {
            updateArtboard({ [CONTEXT_KEYS.IS_PREVIEW]: false });
            setPdfUrl('');
          } 
          if (!DOCUMENT_PREVIEW_ERROR_CODES.includes(res?.errors?.[0]?.code)) {
            isPreview ? message.error(
              t(
                TEMPLATE_PREVIEW_MODAL.ERROR_GENERATING_PREVIEW.key,
                TEMPLATE_PREVIEW_MODAL.ERROR_GENERATING_PREVIEW.value,
              ),
            ) : message.error(
              t(
                TEMPLATE_PREVIEW_MODAL.ERROR_WHILE_DOWNLOAD.key,
                TEMPLATE_PREVIEW_MODAL.ERROR_WHILE_DOWNLOAD.value,
              ),
            );
          }
          if (res?.errors && res?.errors?.[0]?.code === 5604) {
            const originalKey = res?.errors?.[0]?.variable;
            const normalizedKey = originalKey?.replace(/^\[|\]$/g, '');
            const obj = { [normalizedKey]: { invalidImgId: true } };
            setErrorMessages(obj);
            isPreview ? message.error(
              t(
                TEMPLATE_PREVIEW_MODAL.ERROR_GENERATING_PREVIEW.key,
                TEMPLATE_PREVIEW_MODAL.ERROR_GENERATING_PREVIEW.value,
              ),
            ):  message.error(
              t(
                TEMPLATE_PREVIEW_MODAL.ERROR_WHILE_DOWNLOAD.key,
                TEMPLATE_PREVIEW_MODAL.ERROR_WHILE_DOWNLOAD.value,
              ),
            );
            return { success: false };
          }

          setErrorMessages(handleDataValidationErrors(res));
          return { success: false };
        }
        if(response?.status === 402) {
          const { planName, transactionLimit } = userDetails.planMapping;
          updateArtboard({ [CONTEXT_KEYS.UPGRADE_MODAL_INFO]: {
            visible: true,
            message: docGenerationUpgradeMessages(t, planName, transactionLimit)
          } });
          return { success: false };
        } else {
          if (isPreview) {
            setPdfUrl(response.url);
            return { success: true };
          }
        }
      } catch (error) {
        setGeneratingState(false);
        if (isCompleteTransaction) {
          message.error(
            t(
              TEMPLATE_PREVIEW_MODAL.ERROR_WHILE_WEBHOOK_TRANSACTION.key,
              TEMPLATE_PREVIEW_MODAL.ERROR_WHILE_WEBHOOK_TRANSACTION.value,
            ),
          );
        } else {
          if(isPayDownload) {
            message.error(
              t(
                TEMPLATE_PREVIEW_MODAL.ERROR_WHILE_DOWNLOAD.key,
                TEMPLATE_PREVIEW_MODAL.ERROR_WHILE_DOWNLOAD.value,
              ),
            );
          } else {
            message.error(
              t(
                TEMPLATE_PREVIEW_MODAL.ERROR_GENERATING_PREVIEW.key,
                TEMPLATE_PREVIEW_MODAL.ERROR_GENERATING_PREVIEW.value,
              ),
            );
          }
        }
        return { success: false };
      } finally {
        setGeneratingState(false);
        setPayBtnLoading(false);
        if (setLoaderFunc) {
          setLoaderFunc(false);
          setLoaderFunc = undefined;
        }
      }
    },
    [globalVariables, documentVariables, examplValuesData, tagsData, isInteractiveDesign, documentDataSet,
      interactiveDocumentId, isOpenDesign, renderingType, isHybridMail],
  );

  const handleShowDesign = async (toggleButton) => {
    const payLoad = {
      "documentId": documentId,
      "isVisible": !toggleButton
    }

    const response = await showDesignbroadcast(payLoad);

    if (response.statusCode === 3003) {
      setToggleBUtton(!toggleButton)
    } 
  };

  const handleReleaseDesign = async (data) => {
    setDesignReleaseLoading(true);
    setShowOrganizationList(false);
    setOrganizationId(data?.organizationId ? data?.organizationId : 'All');
    const downloadPayload = generatePDFPayload(globalVariables, documentContext, businessLogics, documentStyle, CurrentDesign);
    const { documentDTO } = downloadPayload;
    const complexDocument = await getIndexedDBData('complexDocument');
    
    const documentLIst = await getComplexDocument(documentId);
    if (documentLIst?.statusCode === 707) {
      documentDTO.language = documentLIst?.data?.language;
      documentDTO.tags = documentLIst?.data?.tags;
    }
    // delete documentDTO.documentId;
    documentDTO.id = documentDTO.documentId;
    delete documentDTO.documentId;
    documentDTO.categoryId = complexDocument.categoryId;
    documentDTO.resourceGroup = complexDocument.resourceGroup;
    documentDTO.groupId = complexDocument.groupId;

    let organizationId = {}
    if (data === "All" || data === undefined) {
      organizationId = {};
    } else {
      organizationId = { organizationId: data.organizationId };
    };

    const payLoad = {documentDTO: documentDTO, description: templateDescription}
    const response = await releaseDesignbroadcast(payLoad, organizationId);

    if (response?.statusCode === 3001) {
      message.success(t(
        TEMPLATE_VARIABLES_SIDEBAR.DESIGN_RELEASED_SUCCESSFULLY_MESSAGE.key,
        TEMPLATE_VARIABLES_SIDEBAR.DESIGN_RELEASED_SUCCESSFULLY_MESSAGE.value,
      ))
    }
    setDesignReleaseLoading(false);

    handleShowDesign(false);    
  }

  const preventDownload = (e) => {
    e.preventDefault();
    return false;
  };

  const onDocumentLoadSuccess =({ numPages })=> {
    setNumPages(numPages);
  }

  const setPageVisibility = useCallback((pageNumber, isIntersecting) => {
    if(isIntersecting){ updateArtboard({[CONTEXT_KEYS.PREVIEW_PAGE_NUMBER]:pageNumber }) }
  }, []);

  const batchExcelSample = useCallback((e) => {
    e.domEvent.stopPropagation();
    const {hasMoreThanTwoLevels} = dynamicTableHasMoreThanTwoLevels(documentVariables);
    if(hasMoreThanTwoLevels) {
      message.warning(t(TRANSACTIONS.WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD.key, TRANSACTIONS.WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD.value));
      return;
    }
    const payload = {
      variableContract: documentVariables.map(variable => ({
        type: variable.type,
        id: variable.id,
        name: variable.id ? variable.placeHolderText : variable.name,
        content: variable.variables?.map(childVariable => ({
          type: childVariable.type,
          id: childVariable.id,
          name: childVariable.id ? childVariable.placeHolderText : childVariable.name,
          isArray: childVariable?.isArray,
          content: childVariable.variables?.map(innerChildVariable => ({
            type: innerChildVariable.type,
            id: innerChildVariable.id,
            name: innerChildVariable.id ? innerChildVariable.placeHolderText : innerChildVariable.name
          }))
        }))
      })),
      name: documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.DOCUMENT_NAME]
    };
    console.log({ payload, documentVariables });
    generateSampleExcel(payload, false, isMailRoomModuleEnabled, tagsData);
  }, [documentContext, documentVariables, isMailRoomModuleEnabled, tagsData]);

  useEffect(() => {
    const gotToPageNumber = e => {
      const { pageNumber } = e.detail;
      const element = document.getElementById(`pdfPageNumber-${pageNumber}`);
      if(element) element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };
    const previewElement = document.getElementById('preview-portal');
    previewElement.addEventListener('scrollToPreviewPageNumber', gotToPageNumber);
    return () => {
      previewElement.removeEventListener('scrollToPreviewPageNumber', gotToPageNumber);
    };
  },[])

  const errorLoadinPdf = () => {
    updateArtboard({ [CONTEXT_KEYS.IS_PREVIEW]: false });
    setIsGeneratingPreview(false);
    setPdfUrl('');
    message.error(
      t(
        `TEMPLATE_PREVIEW_MODAL:${TEMPLATE_PREVIEW_MODAL.ERROR_GENERATING_PREVIEW.key}`,
        TEMPLATE_PREVIEW_MODAL.ERROR_GENERATING_PREVIEW.value,
      ),
    );
  };

  const getFlatFilesPayload = async (file) => {
    const {data, delimiter} = await parseFileWithKnownDelimiters(file);
    const payload = generatePayloadFromCsvFile(data, documentVariables, 'draft',documentId);
    return payload;
  }


  const onImportFile = useCallback(async (e) => {
    const file = e.target.files[0];
    let payload;

    if(file){
      e.target.value='';
    const fileFormat = checkFileFormat(file.name) ? 'excel' : file.type;
    if (fileFormat === 'text/plain' || fileFormat === 'text/csv') {
      payload = await getFlatFilesPayload(file);
      if (payload && payload?.length > 0) {
        let uploadFilesLength = payload.length;
        setIsGeneratingPDF(true);
        const env = versionSettingsVisible ? versionsApiMap[currentVisibleVersion] : versionsApiMap[COMPLEX_DOCUMENT_VERSION.DRAFT];
        const response = await uploadEnvDataSet(env, payload || []);

        if (response && response?.statusCode === 200) {
          const synchronous = response?.data?.baseUrl; // assume if baseUrl comes from the backend, this is a sync request
          message.config({ duration: 8 });
          if (synchronous) {
            const directDownloadPayload = response?.data;
            const directDownloadResponse = await staticDownload(directDownloadPayload);
            if (directDownloadResponse?.status === 200) {
              toZipFile(directDownloadResponse?.data, documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.DOCUMENT_NAME]);
              if (uploadFilesLength === response?.data?.fileNames?.length) {
                message.success(t(PDF_TRANSACTIONS.BATCH_DOWNLOAD_SUCCESS_MESSAGE.key, PDF_TRANSACTIONS.BATCH_DOWNLOAD_SUCCESS_MESSAGE.value))
              }
              else if (uploadFilesLength > response?.data?.fileNames?.length) {
                message.success(t(PDF_TRANSACTIONS.BATCH_PARTIAL_DOWNLOAD_SUCCESS_MESSAGE.key,
                  PDF_TRANSACTIONS.BATCH_PARTIAL_DOWNLOAD_SUCCESS_MESSAGE.value, { Downloaded_file: response.data.fileNames.length, Actual_files: uploadFilesLength }));
              }
              setIsGeneratingPDF(false);
            }
            else if (directDownloadResponse?.status === 500) {
              message.error(t(PDF_TRANSACTIONS.BATCH_DOWNLOAD_FAILURE_MESSAGE.key, PDF_TRANSACTIONS.BATCH_DOWNLOAD_FAILURE_MESSAGE.value));
              setIsGeneratingPDF(false);
            }
          }
          // TODO : Add to namespace
          !synchronous && message.success(
            t(
              TEMPLATE_VARIABLES_SIDEBAR.BATCH_UPLOAD_SUCCESS_MESSAGE.key,
              TEMPLATE_VARIABLES_SIDEBAR.BATCH_UPLOAD_SUCCESS_MESSAGE.value,
            ),
          );
          message.config({ duration: 1.5 });
        } else {
          // TODO : Add to namespace
          message.error('Error in submitting batch request!!');
          message.config({ duration: 1.5 });
        }
      }
      else {
        message.error(
          t(
            TRANSACTIONS.PROVIDED_DATA_INVALID_ERROR_MESSAGE.key,
            TRANSACTIONS.PROVIDED_DATA_INVALID_ERROR_MESSAGE.value,
          ),
        );
      }
      setIsGeneratingPDF(false);
      return;
    }
  }

  
    const reader = new FileReader();
    reader.onload = async event => {
      const binaryString = event.target.result;
      const template = {
        variableContract: documentVariables.map(variable => ({
          type: variable.type,
          id: variable.id,
          name: variable.id ? variable.placeHolderText : variable.name,
          placeHolderText: variable?.placeHolderText,
          content: variable.variables?.map(childVariable => ({
            type: childVariable.type,
            id: childVariable.id,
            name: childVariable.id ? childVariable.placeHolderText : childVariable.name,
            isArray: childVariable?.isArray || false,
            placeHolderText: childVariable?.placeHolderText,
            content: childVariable?.variables?.map(subVar => ({
              type: subVar.type,
              id: subVar.id,
              name: subVar.id ? subVar.placeHolderText : subVar.name,
              placeHolderText: subVar?.placeHolderText

            }))
          }))
        })),
        id: documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.ID]
      };
      const requests = getPayloadFromFile(binaryString, file, template, t, false, isMailRoomModuleEnabled, tagsData);
      if (requests === false) {
        message.error(t(`TRANSACTIONS:${TRANSACTIONS.WRONG_FILE_UPLOADED_ERROR_MESSAGE.key}`, TRANSACTIONS.WRONG_FILE_UPLOADED_ERROR_MESSAGE.value));
        return;
      }
      payload = generatePDFPayload(
        globalVariables,
        documentContext,
        businessLogics,
        documentStyle,
        CurrentDesign,
      );
      payload.requests = requests?.map(request => {
        return Object.assign({}, { documentId: documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.ID], dataSet: request.dataSet }, { tagInfo: request?.tagInfo, printable: request?.printable });
      });

      delete payload.documentDTO.documentId;
      delete payload.dataSet;

      setIsGeneratingPDF(true);
      const uploadFilesLength = payload?.requests?.length ;
      const env = versionSettingsVisible ? versionsApiMap[currentVisibleVersion] : versionsApiMap[COMPLEX_DOCUMENT_VERSION.DRAFT];
      const response = await uploadEnvDataSet(env, payload?.requests || []);

    /*const partialSuccess = response?.statusCode === 709 && response?.errors?.some(error => error?.code === 503);
    if(response?.statusCode === 4000 || partialSuccess) {
      message.destroy();
      setIsGeneratingPDF(false);
      if(partialSuccess) { // Partial success; the remaining attempts failed due to exceeding the limit.
        window.open(response?.data);
      }
      const { planName, transactionLimit } = userDetails.planMapping;
      updateArtboard({ [CONTEXT_KEYS.UPGRADE_MODAL_INFO]: {
        visible: true,
        message: docGenerationUpgradeMessages(t, planName, transactionLimit)
      } });
      return;
    }*/
      if (response && response?.statusCode === 200) {
        const synchronous = response?.data?.baseUrl; // assume if baseUrl comes from the backend, this is a sync request
        message.config({ duration: 8 });
      if (synchronous) {
        const directDownloadPayload = response?.data;
        const directDownloadResponse = await staticDownload(directDownloadPayload);
        if (directDownloadResponse?.status === 200) {
          toZipFile(directDownloadResponse?.data, documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.DOCUMENT_NAME]);
          if (uploadFilesLength === response?.data?.fileNames?.length) {
            message.success(t(PDF_TRANSACTIONS.BATCH_DOWNLOAD_SUCCESS_MESSAGE.key, PDF_TRANSACTIONS.BATCH_DOWNLOAD_SUCCESS_MESSAGE.value))
          }
          else if (uploadFilesLength > response?.data?.fileNames?.length) {
            message.success(t(PDF_TRANSACTIONS.BATCH_PARTIAL_DOWNLOAD_SUCCESS_MESSAGE.key,
              PDF_TRANSACTIONS.BATCH_PARTIAL_DOWNLOAD_SUCCESS_MESSAGE.value, { Downloaded_file: response.data.fileNames.length, Actual_files: uploadFilesLength }));
          }
          setIsGeneratingPDF(false);
        }
        else if (directDownloadResponse?.status === 500) {
          message.error(t(PDF_TRANSACTIONS.BATCH_DOWNLOAD_FAILURE_MESSAGE.key, PDF_TRANSACTIONS.BATCH_DOWNLOAD_FAILURE_MESSAGE.value));
          setIsGeneratingPDF(false);
        }
      }
      // TODO : Add to namespace
      !synchronous && message.success(
        t(
          TEMPLATE_VARIABLES_SIDEBAR.BATCH_UPLOAD_SUCCESS_MESSAGE.key,
          TEMPLATE_VARIABLES_SIDEBAR.BATCH_UPLOAD_SUCCESS_MESSAGE.value,
        ),
      );
      message.config({ duration: 1.5 });
    } else {
      // TODO : Add to namespace
      message.error('Error in submitting batch request!!');
      message.config({ duration: 1.5 });
    }
    setIsGeneratingPDF(false)
    /*if (!response || !response.data) {
      if (!response) {
        message.error(
          t(
            `PDF_TRANSACTIONS:${PDF_TRANSACTIONS.TIME_OUT_ERROR_MESSAGE.key}`,
            PDF_TRANSACTIONS.TIME_OUT_ERROR_MESSAGE.value,
          ),
        );
      } else {
        message.error(
          t(
            `PDF_TRANSACTIONS:${PDF_TRANSACTIONS.PDF_GENERATION_FAILED.key}`,
            PDF_TRANSACTIONS.PDF_GENERATION_FAILED.value,
          ),
        );
      }
      setIsGeneratingPDF(false);
    } else {
      if (response && (!response.errors || response.errors.length === 0)) {
        message.success(
          t(
            `PDF_TRANSACTIONS:${PDF_TRANSACTIONS.PDF_GENERATION_SUCCESS.key}`,
            PDF_TRANSACTIONS.PDF_GENERATION_SUCCESS.value,
          ),
        );
        window.open(response.data);
      } else {
        message.error(
          t(
            `PDF_TRANSACTIONS:${PDF_TRANSACTIONS.PDF_GENERATION_FAILED.key}`,
            PDF_TRANSACTIONS.PDF_GENERATION_FAILED.value,
          ),
        );
      }
      setIsGeneratingPDF(false);
    }*/
};
    if (file.type === 'application/json' || file.type === 'application/xml' || file.type === 'text/xml') {
      reader.readAsText(file);
    } else {
      reader.readAsBinaryString(file);
    }
    e.target.value = '';
  }, [documentVariables, globalVariables, documentContext, businessLogics, CurrentDesign, documentStyle, userDetails,tagsData]);

  const envelopeTypeChange = useCallback((value) => {
    updateArtboard({
      [CONTEXT_KEYS.SELECTED_ENVELOPE_TYPE]: value
    })
    methods.setEnvelopeType({
      envelopeType: value
    });
  }, []);

  const deliveryClassChange = useCallback((value) => {
    updateArtboard({
      [CONTEXT_KEYS.DELIVERY_CLASS]: value
    })
  }, []);

  const onStationeryChange = useCallback((value) => {
    console.log({ value });
    updateArtboard({
      [CONTEXT_KEYS.STATIONERY]: value
    });
  }, []);

  const handleClose = async () => {
    if (embedState?.isEmbedded) {
      const transactionEvent = {
        type: PdsClientEventName.CLIENT_INTERACTIVE_DOCUMENT_TRANSACTION_COMPLETE,
        data: responseData.current
      }
      parentWindow.postMessage(transactionEvent, '*');
    }
    else {
      setShowTransacModal(false);
      history.push(`/interactiveTemplates`)
    }
  }

  function handleOpenDesign(showDownload) {
    if(showDownload) {
      setShowSignUpPrompt(true);
    } else {
      updateArtboard({ [CONTEXT_KEYS.SHOW_SIGNUP_PROMPT]: true })
    }
  }

  function handlePayDownload() {
    downloadTemplate(false, undefined, undefined, undefined, undefined, true);
  }

  const previewPortalContainerId = readOnly ? `preview-portal-${artboardVersion}` : 'preview-portal';

  return (
    <Container onKeyDown={e => e.stopPropagation()} isComplexDesign={1}>
      <TitleContainer>
        <RowSection>
          <Title>
            <p>
              {t(
                TEMPLATE_VARIABLES_SIDEBAR.PREVIEW_DOWNLOAD_DESCRIPTION.key,
                TEMPLATE_VARIABLES_SIDEBAR.PREVIEW_DOWNLOAD_DESCRIPTION.value,
              )}
            </p>
          </Title>
        </RowSection>
        {disablePreviewDownload && (
          <RowSection>
            <Title>
              <p className="error-message">
                <Icon type="exclamation-circle" />{' '}
                {t(
                  TEMPLATE_VARIABLES_SIDEBAR.ERROR_IN_DOCUMENT.key,
                  TEMPLATE_VARIABLES_SIDEBAR.ERROR_IN_DOCUMENT.value,
                )}
              </p>
            </Title>
          </RowSection>
        )}
        <RowSection isPreview={1} marginTop>
          {/* <Preview
            isVariablesTab={true}
            sampleDatas={examplValuesData}
            documentVariables={documentVariables}
            globalVariables={globalVariables}
          /> */}
          <DownloadButton
            id={'more-options-download'}
            className="preview"
            onClick={() => {
              if(accessibilityPreview > 0) {
                setAccessibilityPreview(0);
                updateArtboard({ [CONTEXT_KEYS.ENABLED_ACCESSIBILITY_PREVIEW]: false });
              }
              downloadTemplate(true);
            }}
            disabled={disablePreviewDownload}
          >
            <Icon type="eye" theme="filled" style={{ paddingRight: '12px' }} />
            {t(
              TEMPLATE_PREVIEW_MODAL.PREVIEW_DOCUMENT_BUTTON.key,
              TEMPLATE_PREVIEW_MODAL.PREVIEW_DOCUMENT_BUTTON.value,
            )}
            {(!isInteractiveDesign && accessibilityEnabled) ? <Dropdown
              overlay={
                <Menu mode="vertical">
                  <Menu.ItemGroup>
                    <Menu.Item
                      key="1"
                      onClick={(e) => { 
                        e.domEvent.stopPropagation();
                        if(isOpenDesign) {
                          handleOpenDesign();
                        } else {
                          setAccessibilityPreview(count => count + 1);
                          updateArtboard({ [CONTEXT_KEYS.IS_PREVIEW]: true, [CONTEXT_KEYS.ENABLED_ACCESSIBILITY_PREVIEW]: true });
                        }
                      }}>
                        {t(TEMPLATE_PREVIEW_MODAL.ACCESSIBILITY_PREVIEW_BUTTON.key, TEMPLATE_PREVIEW_MODAL.ACCESSIBILITY_PREVIEW_BUTTON.value)}
                      </Menu.Item>
                  </Menu.ItemGroup>
                </Menu>
              }
              placement={'bottomCenter'}
              trigger={['hover']}
              getPopupContainer={() => document.getElementById('more-options-download')}
            >
              <Icon
                type="down"
                style={{ padding: 10, paddingRight: 0 }}
              />
            </Dropdown> : null}
          </DownloadButton>
          {isHybridMail && <DownloadButton
            id={'hrbrid-send-letter'}
            className="preview"
            onClick={() => {
              /*if(accessibilityPreview > 0) {
                setAccessibilityPreview(0);
                updateArtboard({ [CONTEXT_KEYS.ENABLED_ACCESSIBILITY_PREVIEW]: false });
              }
              downloadTemplate(true);*/
            }}
            disabled={disablePreviewDownload}
          >
            {/*t(
              TEMPLATE_PREVIEW_MODAL.PREVIEW_DOCUMENT_BUTTON.key,
              TEMPLATE_PREVIEW_MODAL.PREVIEW_DOCUMENT_BUTTON.value,
            )*/}
            {"Send Letter"}
          </DownloadButton>}
          {(isOpenDesign || checkUserAccessRoles(userDetails, ['DESIGNER', 'PUBLISHER', 'EDITOR'])) && !isHybridMail && <DownloadButton
            ref={transactionRef}
            id={'more-options-download'}
            onClick={() => isOpenDesign ? handleOpenDesign(true) : downloadTemplate()}
            disabled={disablePreviewDownload}
            data-complete-transaction-ref
          >
            {generatingPDF
                ? t(
                  `COMPLEX_VARIABLES_SIDEBAR:${COMPLEX_VARIABLES_SIDEBAR.DOWNLOADING_DOCUMENT_BUTTON.key}`,
                  COMPLEX_VARIABLES_SIDEBAR.DOWNLOADING_DOCUMENT_BUTTON.value,
                )
                : t(
                  `COMPLEX_VARIABLES_SIDEBAR:${COMPLEX_VARIABLES_SIDEBAR.DOWNLOAD_DOCUMENT_BUTTON.key}`,
                  COMPLEX_VARIABLES_SIDEBAR.DOWNLOAD_DOCUMENT_BUTTON.value,
                )}
        {!disablePreviewDownload && !generatingPDF && CurrentDesign === TEMPLATE_TYPE.DOCUMENT && documentVariables.length > 0 && !isInteractiveDesign && !currentVisibleTag?.tagId && (<Dropdown
                  overlay={
                    <Menu mode="vertical">
                      <Menu.ItemGroup title={'Batch download'}>
                        <Menu.SubMenu
                          key="1"
                          title={
                            <span>
                              {t(
                                TEMPLATE_PREVIEW_MODAL.DOWNLOAD_SAMPLE_FORMAT_BUTTON.key,
                                TEMPLATE_PREVIEW_MODAL.DOWNLOAD_SAMPLE_FORMAT_BUTTON.value,
                              )}
                            </span>
                          }
                          popupClassName="custom-download"
                onTitleClick={(e) => { e.domEvent.stopPropagation(); }}
                        >
                      <Menu.Item
                        key="1"
                        onClick={batchExcelSample}
                      >
                        Excel
                      </Menu.Item>
                          <Menu.Item
                            key="2"
                            onClick={(e) => {
                              downloadTemplate(false, true, e)
                            }}
                          >
                            JSON
                          </Menu.Item>
                          <Menu.Item
                            key="3"
                            onClick={(e) => {
                              downloadTemplate(false, true, e, 'xml')
                            }}
                          >
                            XML
                          </Menu.Item>
                          <Menu.Item
                            key="4"
                            onClick={(e) => {
                              downloadTemplate(false, true, e, 'csv')
                            }}
                          >
                            CSV
                          </Menu.Item>
                          <Menu.Item
                            key="5"
                            onClick={(e) => {
                              downloadTemplate(false, true, e, 'tsv')
                            }}
                          >
                            TEXT (Tab Delimited)
                          </Menu.Item>
                          <Menu.Item
                            key="6"
                            onClick={(e) => {
                              downloadTemplate(false, true, e, 'psv')
                            }}
                          >
                            TEXT (Pipe Delimited)
                          </Menu.Item>
                        </Menu.SubMenu>
                          <Menu.Item
                            key="2"
                            onClick={(e) => {
                              e.domEvent.stopPropagation();
                              if (isOpenDesign) {
                                handleOpenDesign()
                              } else {
                                fileRef.current.click();
                              }
                            }}
                          >
                            <div>
                              <input
                                type="file"
                                ref={fileRef}
                                style={{ display: 'none' }}
                                onInput={onImportFile}
                              />
                              {t(
                                TEMPLATE_PREVIEW_MODAL.BUlk_UPLOAD_DOCUMENT_BUTTON.key,
                                TEMPLATE_PREVIEW_MODAL.BUlk_UPLOAD_DOCUMENT_BUTTON.value,
                              )}
                            </div>
                          </Menu.Item>
                      </Menu.ItemGroup>
                    </Menu>
                  }
                  placement={'bottomRight'}
                  trigger={['hover']}
                  getPopupContainer={() => document.getElementById('more-options-download')}
                >
                  <Icon
                    type="down"
                    style={{ padding: 10, paddingRight: 0 }}
               onClick={(e) => {
                      e.stopPropagation();
                    }}
                  />
             </Dropdown>)}
            {(generatingPDF) && (
               <Spin style={{ paddingLeft: 10 }} indicator={<Icon type="loading" style={{ color: 'black' }} />}></Spin>
            )}
          </DownloadButton>}
        </RowSection>

        {CurrentDesign === TEMPLATE_TYPE.DOCUMENT && checkSessionUserAccess(userDetails, 'master') && (
          <RowSection isPreview={1} releaseBtn marginTop>
            <div className="swith-btn">
              {' '}
              <Switch checked={toggleButton} onChange={() => handleShowDesign(toggleButton)} />{' '}
              &nbsp; &nbsp;
              {t(
                `COMPLEX_VARIABLES_SIDEBAR:${COMPLEX_VARIABLES_SIDEBAR.SHOW_DESIGN_BUTTON.key}`,
                COMPLEX_VARIABLES_SIDEBAR.SHOW_DESIGN_BUTTON.value,
              )}
            </div>
            <Button onClick={() => setShowOrganizationList(true)}  loading={designReleaseLoading}>
              {t(
                `COMPLEX_VARIABLES_SIDEBAR:${COMPLEX_VARIABLES_SIDEBAR.RELEASE_DESIGN_BUTTON.key}`,
                COMPLEX_VARIABLES_SIDEBAR.RELEASE_DESIGN_BUTTON.value,
              )}
            </Button>
          </RowSection>
        )}

        {isHybridMail && ( // TODO : Continue from here to persist and save envelope type and delivery class
          <>
          <RowSection isPreview={1} marginTop>
              <span style={{ color: 'white' }}>
                {'Envelope Type'}
                &nbsp; &nbsp;
              </span>
              <Select
                optionFilterProp="children"
                value={envelopeType}
                style={{ minWidth: '50%' }}
                onChange={envelopeTypeChange}
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option key={'C5'} value={'C5'} selected>
                  <Tooltip key={'C5'} placement="topLeft" title={'C5'}>{'C5'}</Tooltip>
                </Option>
                <Option key={'C4'} value={'C4'} selected>
                  <Tooltip key={'C4'} placement="topLeft" title={'C4'}>{'C4'}</Tooltip>
                </Option>
                <Option key={'DL'} value={'DL'} selected>
                  <Tooltip key={'DL'} placement="topLeft" title={'DL'}>{'DL'}</Tooltip>
                </Option>
              </Select>
          </RowSection>
          <RowSection isPreview={1} marginTop>
              <span style={{ color: 'white' }}>
                {'Delivery class'}
                &nbsp; &nbsp;
              </span>
              <Select
                optionFilterProp="children"
                defaultValue={'1'}
                value={deliveryClass}
                style={{ minWidth: '50%' }}
                onChange={deliveryClassChange}
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option key={'1'} value={1} selected>
                  <Tooltip key={'1'} placement="topLeft" title={'1'}>{'First Class'}</Tooltip>
                </Option>
                <Option key={'2'} value={2} selected>
                  <Tooltip key={'2'} placement="topLeft" title={'2'}>{'Second Class'}</Tooltip>
                </Option>
              </Select>
          </RowSection>
          <RowSection isPreview={1} marginTop>
              <span style={{ color: 'white' }}>
                {'Stationery'}
                &nbsp; &nbsp;
              </span>
              <Select
                optionFilterProp="children"
                value={selectedStationery}
                style={{ minWidth: '50%' }}
                onChange={onStationeryChange}
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {stationeryList.map((stationery, index) =>
                  (
                    <Option key={stationery.parentBlockId} value={stationery.parentBlockId} selected={stationery.parentBlockId === selectedStationery}>
                      <Tooltip key={stationery.parentBlockId} placement="topLeft" title={stationery.parentBlockName}>{stationery.parentBlockName}</Tooltip>
                    </Option>
                ))}
              </Select>
          </RowSection>
          </>
        )}
      </TitleContainer>
      {!embedState?.hideDesignSidebar && <ListContainer>
        <VariableForm
          documentVariables={documentVariables}
          examplValuesData={examplValuesData}
          setExamplValuesData={setExamplValuesData}
          errorMessages={errorMessages}
          isHtmlExpanded={isHtmlExpanded}
          setIsHtmlExpanded={setIsHtmlExpanded}
          isInteractiveDesign={isInteractiveDesign}
        />
      </ListContainer>}
      {(pdfUrl || generatingPreview || accessibilityPreview > 0) &&
        document.getElementById(previewPortalContainerId) &&
        ReactDOM.createPortal(
          <div className="preview-portal-container">
            <div
              className="preview-portal-document-container"
              id="PreviewPdfDocument"
              onContextMenu={preventDownload}
              ref={containerRef}
            >
              {accessibilityPreview > 0 ?
                <AccessibilityPreview key={accessibilityPreview} PreviewLoader={PreviewLoader} documentVariables={documentVariables} examplValuesData={examplValuesData} />
              : generatingPreview ? (
                <PreviewLoader />
              ) : (
                <Document
                  file={pdfUrl}
                  onLoadSuccess={onDocumentLoadSuccess}
                  loading=""
                  error=""
                  onLoadError={errorLoadinPdf}
                  externalLinkTarget={'_blank'}
                  onItemClick={dummyCallback}
                >
                  {Array.from(new Array(numPages), (el, index) => (
                    <div
                      key={`page_${index + 1}`}
                      className="pageLayout"
                      id={`pdfPageNumber-${index + 1}`}
                    >
                      <PreviewPageWithObserver
                        key={`page-${index + 1}`}
                        pageNumber={index + 1}
                        setPageVisibility={setPageVisibility}
                      />
                    </div>
                  ))}
                </Document>
              )}
            </div>
          </div>,
          document.getElementById(previewPortalContainerId),
        )}
      {showOrganizationList &&
        <SelectOrganization
          organizationId={organizationId}
          visible={showOrganizationList}
          onCancel={() => setShowOrganizationList(false)}
          handleClick={(data) => handleReleaseDesign(data)} />}

      {showTransacModal && 
        <TransactionCompleteModal
              visible={showTransacModal}
              onClose = {()=>handleClose()}
        />}
      {
        <SignUpPrompt
        visible={isOpenDesign && showSignUpPrompt}
        onCancel={() => setShowSignUpPrompt(false)}
        onSignUp={() => {
          setShowSignUpPrompt(false);
          // TODO: Add sign up logic
        }}
        showPayBtn={true}
        handlePayDownload={handlePayDownload}
        payBtnLoading={payBtnLoading}
      />
      }
    </Container>
  );
};

export default ComplexVariablesList;
